import { useEffect, useState } from "react";
import api from "../api/api";

export default function Companies() {
  const [data, setData] = useState([]);

  const loggedInUser = JSON.parse(localStorage.getItem("user"));

  const [form, setForm] = useState({
    comp_id: "",
    company_name: "",
    gst_no: "",
    adress: "",
    city: "",
    state: "",
    country: "",
  });

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const res = await api.get("/company");
      setData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const addCompany = async () => {

    if (form.comp_id && form.comp_id.length < 4) {
      return alert("ID too short");
    } // ye add Id

    if (!form.company_name || !form.city || !form.state || !form.country || !form.gst_no || !form.adress) {
      return alert("Company name, city, state, country, GST & Address are required");
    }

    try {
      await api.post("/company", form);

      setForm({
        comp_id: "",
        company_name: "",
        gst_no: "",
        adress: "",
        city: "",
        state: "",
        country: "",
      });

      load();
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCompany = async (id) => {
    try {
      await api.delete(`/company/${id}`);
      load();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center -mt-10">
    
      <h2 className="text-4xl font-semibold text-[#030244] mb-10">
        Company Management
      </h2>

      {/* FORM */}
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-lg border">
        <h3 className="text-2xl text-center font-semibold mb-6 text-gray-900">
          Add New Company
        </h3>

        <div className="flex flex-col gap-4">
          <input
            placeholder="Company ID"
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.comp_id}
            onChange={(e)=>setForm({...form, comp_id:e.target.value})}
          />

          <input
            placeholder="Company Name"
            className="border p-2 rounded w-full focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.company_name}
            onChange={(e) => setForm({ ...form, company_name: e.target.value })}
          />

          <input
            placeholder="GST Number"
            className="border p-2 rounded w-full focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.gst_no}
            onChange={(e) => setForm({ ...form, gst_no: e.target.value })}
          />

          <input
            placeholder="Address"
            className="border p-2 rounded w-full focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.adress}
            onChange={(e) => setForm({ ...form, adress: e.target.value })}
          />

          <input
            placeholder="City"
            className="border p-2 rounded w-full focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.city}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
          />

          <div className="grid grid-cols-2 gap-3">
            <input
              placeholder="State"
              className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
              value={form.state}
              onChange={(e) => setForm({ ...form, state: e.target.value })}
            />

            <input
              placeholder="Country"
              className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
              value={form.country}
              onChange={(e) => setForm({ ...form, country: e.target.value })}
            />
          </div>
        </div>

        <button
          onClick={addCompany}
          className="mt-8 w-full bg-[#030244] text-white text-lg py-2 rounded-lg hover:bg-[#01038b]"
        >
          + Add Company
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow-lg w-full max-w-5xl mt-12 overflow-hidden">
        <div className="overflow-x-auto">
        <table className="min-w-[900px] w-full">
          <thead className="bg-[#030244] text-white text-xl">
            <tr>
              <th className="p-3 text-center border font-medium">S.No</th>
              <th className="p-3 text-center border font-medium">ID</th>
              <th className="p-3 text-center border font-medium">Company</th>
              <th className="p-3 text-center border font-medium">GST</th>
              <th className="p-3 text-center border font-medium">Address</th>
              <th className="p-3 text-center border font-medium">City</th>
              <th className="p-3 text-center border font-medium">State</th>
              <th className="p-3 text-center border font-medium">Country</th>
              <th className="p-3 text-center border font-medium">Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
                <tr>
                    <td colSpan="9" className="text-center p-4 text-xl font-medium">
              No Data Found
            </td>
                </tr>
            ) : (
             data.map((c, index) => (
              <tr key={c.comp_id} className="border-b text-lg">
                <td className="p-3 text-center border text-gray-600">{index + 1}</td>
                <td className="p-3 text-left border text-gray-600">{c.comp_id}</td>
                {/* <td className="p-4 text-gray-500">{c.comp_id.slice(0,6)}</td> */}

                <td className="p-3 text-center border text-gray-700">{c.company_name}</td>

                <td className="p-3 text-center border text-gray-700">{c.gst_no}</td>

                <td className="p-3 text-center border text-gray-700">{c.adress}</td>

                <td className="p-3 text-center border text-gray-700">{c.city}</td>

                <td className="p-3 text-center border text-gray-700">{c.state}</td>

                <td className="p-3 text-center border text-gray-700">{c.country}</td>

               <td className="p-3 text-center border">
                
                {loggedInUser?.role === "super_admin" ? (
                  <button
                    onClick={() => deleteCompany(c.comp_id)}
                    className="bg-[#da0c0c] hover:bg-red-600 text-white px-3 py-1 rounded-md"
                  >
                    Delete
                  </button>
                ) : (
                  <span className="text-gray-500 italic">No Access</span>
                )}

              </td>
              </tr>
             ))
            )}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );
}




// import { useEffect,useState } from "react";
// import api from "../api/api";

// export default function Companies(){

//  const [data,setData]=useState([]);
//  const [search,setSearch]=useState("");

//  useEffect(()=>{
//   load();
//  },[]);

//  const load = async()=>{
//   const res = await api.get("/company");
//   setData(res.data);
//  };

//  const filtered = data.filter(c=>
//   c.company_name.toLowerCase().includes(search.toLowerCase())
//  );

//  return(

//  <div className="ml-64 p-6">

//  <h2 className="text-xl mb-4">Companies</h2>

//  <input
//  className="border p-2 mb-4"
//  placeholder="search company"
//  value={search}
//  onChange={(e)=>setSearch(e.target.value)}
//  />

//  <table className="w-full bg-white shadow">

//  <thead>

//  <tr className="bg-gray-200">
//  <th>Name</th>
//  <th>City</th>
//  </tr>

//  </thead>

//  <tbody>

//  {filtered.map(c=>(
//  <tr key={c.comp_id}>

//  <td>{c.company_name}</td>
//  <td>{c.city}</td>

//  </tr>
//  ))}

//  </tbody>

//  </table>

//  </div>

//  );
// }
